import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLimitSwapPair, useLimitOrderUserConfig } from '~/state/dex/hooks'
import { updateLimitOrderUserConfig } from '~/state/dex/actions'
import { useAppDispatch } from '~/state/hooks'
import {
  StyledLimitPriceWrapper,
  StyledRateWrapper,
  StyledRateDetail,
  SwitchIcon,
} from './styled'
import IconSwitch from '~/assets/images/switch-round.svg'
import { useBreakpoint } from '~/hooks'
import { useLimitOrderPrices } from '../../hooks/useLimitOrderPrices'

const LimitPriceWrapper: React.FC = () => {
  const { t } = useTranslation()
  const { isMobile } = useBreakpoint()
  const dispatch = useAppDispatch()

  const [inputToken, outputToken] = useLimitSwapPair()

  const [leftToken, setLeftToken] = useState<LimitSwapToken>(inputToken)
  const [rightToken, setRightToken] = useState<LimitSwapToken>(outputToken)

  const { isInputRateDirection } = useLimitOrderUserConfig()

  const { displayLimitPrice, displayLimitPriceValue } = useLimitOrderPrices({
    inputToken,
    outputToken,
    isInputRateDirection,
  })

  useEffect(() => {
    setLeftToken(isInputRateDirection ? inputToken : outputToken)
    setRightToken(isInputRateDirection ? outputToken : inputToken)
  }, [inputToken?.address, outputToken?.address, isInputRateDirection])

  const onSwitch = () => {
    dispatch(
      updateLimitOrderUserConfig({
        isInputRateDirection: !isInputRateDirection,
      }),
    )
  }

  return (
    <StyledLimitPriceWrapper>
      <span>{t('limit_price')}</span>
      <StyledRateWrapper>
        <StyledRateDetail>
          <span>1 {leftToken?.symbol}</span>
          <SwitchIcon onClick={onSwitch} src={IconSwitch} />
          <span className="boldText">
            {displayLimitPrice} {rightToken?.symbol}{' '}
            {isMobile ? '' : displayLimitPriceValue}
          </span>
        </StyledRateDetail>
      </StyledRateWrapper>
    </StyledLimitPriceWrapper>
  )
}

export default LimitPriceWrapper
